export const locale = {
  lang: "fr-CA",
  data: {
    PHOTO_LIBRARY_PANEL: {
      TITLE: "Sélectionner une image dans la bibliothèque",
      TAB_MINE: "Ma bibliothèque",
      TAB_GT: "Bibliothèque GT",
      SEARCH: "Rechercher",
      EMPTY: "Aucune image trouvée.",
      ADD: "Ajouter",
    },
  },
};
